import { inject, bindable, TaskQueue } from 'aurelia-framework';
import { EventAggregator } from 'aurelia-event-aggregator';
import { DialogController } from 'aurelia-dialog';
import { DialogService } from 'aurelia-dialog';
import { ProcessService } from 'pages/standard-setup/processes/service';
import { MachineService } from 'pages/standard-setup/machines/service';
import { StageService } from 'pages/system-fields/stages/service';
import { UnitOfMeasurementService } from 'pages/system-fields/unit-of-measurements/service';
import { QuoteService } from 'pages/quotes/service';
import { toParsedFloat } from 'resources/utility';
import moment from 'moment';
import toastr from 'toastr';

@inject(DialogController, EventAggregator, DialogService, MachineService, ProcessService, StageService, UnitOfMeasurementService, QuoteService, TaskQueue)
export class QuoteProcessesEdit {
    @bindable quoteProcesses;
    @bindable quote;

    constructor(controller, ea, dialogService, machineService, processService, stageService, unitOfMeasurementService, quoteService, taskQueue) {
        this.controller = controller;
        this.ea = ea;
        this.dialogService = dialogService;
        this.machineService = machineService;
        this.processService = processService;
        this.stageService = stageService;
        this.unitOfMeasurementService = unitOfMeasurementService;
        this.quoteService = quoteService;
        this.taskQueue = taskQueue;
        this.showEdit = false;
        this.totals = {};

        this.deleted = 0;
        this.added = 0;
        this.edited = 0;

        this.subscription = this.ea.subscribe('quote-procceses:changed', () => {
          this.getTotals();
          this.added = this.quoteProcesses.filter(x => x.isAdded).length;
          this.edited = this.quoteProcesses.filter(x => !x.isAdded && x.isEdit).length;
          this.quoteProcesses.map(item => {
            item.pricePer = this.pricePerCalc(item);
          });
        });
        
        this.saveSubscription = this.ea.subscribe('quotes:updated', async() => {
          const ids = await this.quoteService.getQuoteProcessIdsForQuote(this.quote.id);
          let i = 0;
          this.quoteProcesses.map(item => {
            item.isAdded = false;
            item.isEdit = false;
            item.id = ids[i];
            i++;
          });
          this.deleted = 0;
          this.added = 0;
          this.edited = 0;
          this.ea.publish('quote-procceses:changed');
        });

        this.ea.subscribe('quote:reload', () => {
          this.taskQueue.queueMicroTask(() => {
            this.loadProcesses();
          });
        });
    }

    loadProcesses = () => {
      if (this.quoteProcesses == undefined) {
        this.quoteProcesses = [];
      }
      else {
        this.getTotals();
      }
    };

    attached() {
      this.loadProcesses();
      this.name = window.localStorage.getItem('name');
      if ((this.quote.lockedAt != null && this.quote.lockedBy.toLowerCase() != this.name.toLowerCase() && moment().utc().diff(moment(this.quote.lockedAt), 'minutes') < 20) || this.quote.isSnapshot) {
        this.isReadonly = true;
      }
    }


    addItem() {
      const volume = this.quote.volumePerMonth ? this.quote.volumePerMonth : 0;
      if (volume == 0) {
        toastr.error("Volume for quote must have a value");
        return;
      }

      this.dialogService.open({ viewModel: this.quoteService.quoteProcessEditor, model: {quoteProcesses: this.quoteProcesses, quote: this.quote, isEdit: false } })
      .whenClosed(response => {
        if (!response.wasCancelled) {
            this.quoteProcesses.push(response.output);
            this.ea.publish('quote-procceses:changed');
            if (response.output.isContinueAdd) {
              this.addItem();
            }
          }
      });
    }

    editItem(index) {
      this.dialogService.open({ viewModel: this.quoteService.quoteProcessEditor, model: { quoteProcesses: this.quoteProcesses, quote: this.quote, isEdit: true, index }})
      .whenClosed(response => {
        if (!response.wasCancelled) {
          console.log(response.output);
          response.output.isEdit = true;
          this.quoteProcesses[index] = response.output;
          this.quoteProcesses = [...this.quoteProcesses];
          this.ea.publish('quote-procceses:changed');
        } else {
          this.quoteProcesses[index].isEdit = false;
        }
      });
    }

    removeItem(index) {
      if (!this.quoteProcesses[index].isAdded) {
        this.deleted++;
      }
      else {
        this.added--;
      }
      this.quoteProcesses[index].deleted = true;
      this.ea.publish('quote-procceses:changed');
    }

    addProcess() {
      this.dialogService.open({ viewModel: this.processService.editor });
    }

    getTotals() {
      this.totals.other = this.getTotalForWorkCenter("OTHER");
      this.totals.stamping = this.getTotalForWorkCenter("STAMPING");
      this.totals.welding = this.getTotalForWorkCenter("WELDING");
      this.quoteProcesses.map(item => {
        item.pricePer = this.pricePerCalc(item);
      });
      this.quote.quoteProcessTotals = this.totals;
    }

    getTotalForWorkCenter(workCenter) {
      let processes = this.quoteProcesses.filter(item => { return item.workCenter === workCenter && !item.deleted }); 
      if (processes.length == 0) {
        return 0.0000;
      }
      let result = processes.map(item => this.pricePerCalc(item))
                            .reduce((prev, next) => Number(prev) + Number(next));
      return toParsedFloat(result);
    }

    pricePerCalc(item) {
      if (item.numberOrQuantity == 0) {
        return 0.0000;
      }
      if (item.workCenter != "STAMPING") {
        return toParsedFloat(item.numberOrQuantity * item.unitPrice * (item.useGangFactor ? item.gangFactor : 1));
      }
      return this.toFloat(item.unitPrice / item.numberOrQuantity * (item.useGangFactor ? item.gangFactor : 1));
    }

    toFloat(value) {
      let valueFloated = toParsedFloat(value, 10);
      let stripped = valueFloated.substring(0, valueFloated.indexOf('.') + 5);
      return stripped;
    }

}
